<app-card class="h-full" rootClass="h-full" bodyClass="h-full" contentClass="h-full">
    <div class="flex flex-col">
        <div class="flex items-center justify-between border-b border-dividerBorder p-5 pt-4">
            <div class="text-subheading-large text-headingText">Notifications & Tasks</div>
            <a [routerLink]="['/notifications']" class="text-body-medium font-medium text-inputFocusBorder underline cursor-pointer">View all</a>
        </div>
        <div class="flex flex-col gap-5 p-5">
            @if (!notifications.length) {
            <div class="flex items-center justify-center min-h-[200px] text-bodyText">No data available</div>
            } @else {
            @for (group of notifications; track group.label) {
            <div class="col-span-12 flex flex-col gap-5" [class.mt-5]="!$first">
                <span class="text-label-small text-bodyText">{{ group.label }}</span>
                <ul class="flex flex-col gap-5">
                    @for (item of group.items; track $index) {
                    <li class="flex items-center gap-2">
                        @switch (item.icon) {
                        @case ('blue') {
                        <svg-icon src="/icons/blue-icon.svg" svgClass="w-5 h-5 text-blue-500"></svg-icon>
                        }
                        @case ('check') {
                        <svg-icon src="/icons/check-circle.svg" svgClass="w-5 h-5 text-green-500"></svg-icon>
                        }
                        @case ('yellow') {
                        <svg-icon src="/icons/yellow-icon.svg" svgClass="w-5 h-5 text-yellow-500"></svg-icon>
                        }
                        @default {
                        <svg-icon src="/icons/blue-icon.svg" svgClass="w-5 h-5 text-blue-500"></svg-icon>
                        }
                        }
                        <span class="text-body-large text-bodyText">
                            {{ item.message }}
                            @if (item.amount != null) {
                            <app-currency-display
                              [value]="item.amount"
                              [currencyCode]="item.currency ?? 'USD'"
                            />
                            }
                            @if (item.percent != null) {
                            {{ item.percent }}%.
                            }
                        </span>
                    </li>
                    @if (!$last) {
                    <app-divider [style]="{margin: '0px'}"></app-divider>
                    }
                    }
                </ul>
            </div>
            @if (!$last) {
            <app-divider [style]="{margin: '0px'}"></app-divider>
            }
            }
            }
        </div>
    </div>
</app-card>